import type { Screen } from "../../app/api/ApiClient";
import type { StateStore } from "../../app/state/StateStore";

import { ScreenMapper } from "./ScreenMapper";

type AuthScreen = Extract<Screen, { type: "auth" }>;

export class AuthScreenMapper
    implements ScreenMapper<AuthScreen> {

    public readonly type = "auth" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    public apply(
        screen: AuthScreen
    ): void {

        const state =
            this.store.getState();

        this.store.replace({

            ...state,

            primaryScreen: {

                type: "auth"

            },

            isLoading: false

        });

    }

}